var _Path, _Path2, _Path3, _Path4, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg";
var SvgInviteAdultEmail = function SvgInviteAdultEmail(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 132,
    height: 132
  }, props), /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#invite_adult_email_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: props.fillLine,
    d: "m65.528 12 53.528 39.8v67.582H12.001V51.803zm50.852 41.148L65.528 15.336 14.677 53.148v63.561h101.7z"
  }), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fillOpacity: 0.2,
    d: "m65.528 12 53.528 39.8v67.582H12.001V51.803zm50.852 41.148L65.528 15.336 14.677 53.148v63.561h101.7z"
  })), /*#__PURE__*/React.createElement(Path, {
    fill: props.fillLine,
    d: "M116.869 119.082 65.528 76.956l-51.34 42.126-1.7-2.069 53.04-43.519 53.038 43.519z"
  }), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    fillOpacity: 0.2,
    d: "M116.869 119.082 65.528 76.956l-51.34 42.126-1.7-2.069 53.04-43.519 53.038 43.519z"
  })), /*#__PURE__*/React.createElement(Path, {
    fill: props.fillLine,
    d: "M49.603 89.567 12.407 53.436l1.864-1.92 37.2 36.131z"
  }), _Path3 || (_Path3 = /*#__PURE__*/React.createElement(Path, {
    fillOpacity: 0.2,
    d: "M49.603 89.567 12.407 53.436l1.864-1.92 37.2 36.131z"
  })), /*#__PURE__*/React.createElement(Path, {
    fill: props.fillLine,
    d: "m82.097 89.559-1.88-1.9 36.561-36.135 1.878 1.904z"
  }), _Path4 || (_Path4 = /*#__PURE__*/React.createElement(Path, {
    fillOpacity: 0.2,
    d: "m82.097 89.559-1.88-1.9 36.561-36.135 1.878 1.904z"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "invite_adult_email_svg__a"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    d: "M12 12h107.055v107.385H12z"
  })))));
};
export default SvgInviteAdultEmail;